import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@systemeio/ui';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { eventTypeDescriptionLocoKeys, eventTypeTitleLocoKeys } from '../constants/event-type-translation-dictionary';
import { WebhookSubscriptionEventEnum } from '../types/webhook-settings-interface';
interface EventTypesSelectProps {
  selected: Record<WebhookSubscriptionEventEnum, boolean>;
  onSelect: (eventType: WebhookSubscriptionEventEnum) => void;
  disabled?: boolean;
  error?: string;
}
const eventTypes = Object.values(WebhookSubscriptionEventEnum);
const EventTypesSelect = t0 => {
  const $ = _c(14);
  const {
    selected,
    onSelect,
    disabled,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onSelect) {
    t1 = eventType => () => onSelect(eventType);
    $[0] = onSelect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== disabled || $[3] !== handleChange || $[4] !== selected || $[5] !== t) {
    t2 = eventTypes.map(et => <Checkbox disabled={disabled ?? false} key={et} onChange={handleChange(et)} className="items-start" label={<><span className="text-text-primary">{t(eventTypeTitleLocoKeys[et])}</span><span className="text-text-primary/50">{t(eventTypeDescriptionLocoKeys[et])}</span></>} labelClassName="flex flex-col" value={selected[et]} />);
    $[2] = disabled;
    $[3] = handleChange;
    $[4] = selected;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="grid grid-cols-2 gap-5">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== error) {
    t4 = error && <FieldErrorAndDescription error={error} errorClassName="mt-5" />;
    $[9] = error;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="p-6">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default EventTypesSelect;